<template>
  <FixedFooter class="main-footer">
    <div class="copyright">{{ copyrightText }}</div>
    <div class="ssl">
      <GlobalSignImage />
    </div>
  </FixedFooter>
</template>

<script>
import { FixedFooter } from '@n11/so-ui-components';
import GlobalSignImage from '@/components/Footer/GlobalSignImage';

export default {
  components: {
    FixedFooter,
    GlobalSignImage,
  },
  setup() {
    const currentYear = new Date().getFullYear();
    const copyrightText = `© Copyright 2012-${currentYear} n11.com`;
    return {
      copyrightText,
    };
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/variables.scss';

.main-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: static;
  margin-top: 15px;

  .copyright {
    font-size: 13px;
    color: $dark-gray-5;
    text-align: center;
    line-height: normal;
  }
}
</style>
